import { RouterModule, Routes } from "@angular/router";

//Components
import { LoginExecutiveComponent } from "./login/login-executive/login-executive.component";
import { LoginComponent } from "../auth/login/login.component";
import { LoginCompanyComponent } from "./login/login-company/login-company.component";
import { CreateAccountComponent } from "./account/create-account.component";
import { CreateCompanyComponent } from "./account/create-company/create-company.component";
import { CreateAdminComponent } from './account/create-admin/create-admin.component';
import { CreateAccountSuccessComponent } from "./account/create-account-success/create-account-success.component";
import { CreatePasswordComponent } from "./password/create-password/create-password.component";
import { EnterCodeComponent } from "./password/enter-code/enter-code.component";
import { NewPasswordComponent } from "./password/new-password/new-password.component";
import { NewPasswordSuccessComponent } from "./password/new-password/new-password-success/new-password-success.component";
import { RecoverPasswordComponent } from "./password/recover-password/recover-password.component";
import { AdminDataComponent } from "./password/recover-password/admin-data/admin-data.component";

const AUTH_ROUTES: Routes = [
  { path: "login", component: LoginComponent },
  { path: "login/company", component: LoginCompanyComponent },
  { path: "login/executive", component: LoginExecutiveComponent },
  {
    path: "create-account",
    component: CreateAccountComponent,
    children: [
      { path: "company", component: CreateCompanyComponent },
      { path: "admin", component: CreateAdminComponent },
      { path: "success", component: CreateAccountSuccessComponent },
      { path: "", redirectTo: "company", pathMatch: "full" },
    ],
  },
  {
    path: "create-password",
    component: CreatePasswordComponent,
    children: [
      {
        path: "enter-code",
        component: EnterCodeComponent,
        data: { step: 1, operation: "create" },
      },
      {
        path: "new-password",
        component: NewPasswordComponent,
        data: { step: 2, operation: "create" },
      },
      { path: "success", component: NewPasswordSuccessComponent },
      { path: "", redirectTo: "enter-code", pathMatch: "full" },
    ],
  },
  {
    path: "recover-password",
    component: RecoverPasswordComponent,
    children: [
      { path: "admin-data", component: AdminDataComponent },
      {
        path: "enter-code",
        component: EnterCodeComponent,
        data: { step: 2, operation: "recover" },
      },
      {
        path: "new-password",
        component: NewPasswordComponent,
        data: { step: 3, operation: "recover" },
      },
      { path: "success", component: NewPasswordSuccessComponent },
      { path: "", redirectTo: "admin-data", pathMatch: "full" },
    ],
  },
];
export const AUTH_ROUTING = RouterModule.forChild(AUTH_ROUTES);
